import React from "react";

import styled from "styled-components/macro";

import { useSignups } from "Signups/state.js";

import { colors } from "UI/colors";

import FundButton from "./FundButton";

export default function SignupFundSetting() {
  const [
    {
      currentSignupList: {
        fundIt: { fund },
      },
      user: { canViewGiving },
    },
  ] = useSignups();

  if (!fund?.ID) return null;

  return (
    <Wrapper>
      <div>Which fund should payments be allocated to?</div>

      <FundButtonOrName>
        {canViewGiving ? (
          <FundButton currentFund={fund} />
        ) : (
          <FundNameReadOnly>{fund.name}</FundNameReadOnly>
        )}
      </FundButtonOrName>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  font-size: 15px;
  font-weight: 400;
  margin-top: 24px;
`;

const FundButtonOrName = styled.div`
  margin-top: 4px;
`;

const FundNameReadOnly = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${colors.fnGray700};
`;
